import React from 'react';

import { Alert as MuiAlert, AlertProps as MuiAlertProps } from '@mui/material';

import styles from './Alert.module.scss';

export type AlertSeverity = 'info' | 'success' | 'warning' | 'error';

export interface AlertProps extends Omit<MuiAlertProps, 'severity' | 'variant' | 'color'> {
    /**
     * The message text of the alert
     */
    children: React.ReactNode;
    /**
     * The severity/type of the alert
     */
    severity?: AlertSeverity;
}

/**
 * Custom Alert component based on MUI Alert
 * Implements design system styling from Figma atoms Info Statements component
 * Supports light and dark themes via CSS variables
 */
export const Alert: React.FC<AlertProps> = ({ children, severity = 'info', className = '', ...props }) => {
    const alertClass = [styles.alert, styles[severity], className].filter(Boolean).join(' ');

    return (
        <MuiAlert className={alertClass} severity={severity} {...props}>
            {children}
        </MuiAlert>
    );
};

export default Alert;
